import { useEffect, useState } from 'react';
import { OlympiadsApi } from 'api';
import { Widget } from 'models/widgetMultiStageOlympiad';

export interface IMunicipalityStatistics {
  subjectId: number;
  subjectName: string;
  value: number;
  participantsCount: number;
  realStudentsCount: number;
}

export const useMunicipalityStatistics = (widget: Widget) => {
  const [pendingMunicipalityRating, setPendingMunicipalityRating] = useState(false);
  const [municipalityRating, setMunicipalityRating] = useState<IMunicipalityStatistics[]>();

  const today = new Date();
  const finishDate = new Date(widget.dateSecondTourEnd);
  finishDate.setHours(23, 59, 59, 999);

  const olympStatus = today > new Date(finishDate) ? 'passed' : 'current';

  useEffect(() => {
      fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setPendingMunicipalityRating(true);
      const result = await OlympiadsApi.getMunicipalityRatingsByOlympiads(widget.currentYear, olympStatus);
      const olimp = result.find((r) => r.olympiad_id === widget.firstOlympId);
      const data = olimp?.ratings?.map((el) => ({
        subjectId: el.subject_id,
        subjectName: el.subject_name,
        participantsCount: el.participants_count,
        realStudentsCount: el.real_students_count,
        value: el.value,
      }));
      const sortedData = data?.sort((a, b) => b.value - a.value);
      setMunicipalityRating(sortedData);
    } catch (e) {
      console.error(e)
    } finally {
      setPendingMunicipalityRating(false);
    }
  };
  
  return { municipalityRating, pendingMunicipalityRating, olympStatus };
};
